const userFriendlyError = message => {
    const error = new Error(message);
    error.name = 'UserFriendlyError';
    return error;
};

export default userFriendlyError;
